<template lang="html">
  <div class="step3">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content row">
        <div class="ibox-title col-sm-12">
            <h5 class="text-center">会员登记申请</h5>
        </div>
        <div class="box col-sm-12 row">
          <div class="">
            <div class="col-sm-12">
              <h5 class="sub-tit"><span class="red"></span>工作经历：   </h5>
            </div>
          </div>
          <div class="col-sm-11" style="padding:5px;overflow-x:auto;">
            <table class="table border">
              <thead class="">
                <tr scope="row" >
                  <th scope="col">起始年月</th>
                  <th scope="col">结束年月</th>
                  <th scope="col">主要经历</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <step-third v-bind:index="index" v-on:getRemoveIndex="catchRemoveIndex" v-on:getFormData="catchFormData" v-for="(item,index) in inputGroup" :key="index"></step-third>
              </tbody>
            </table>
          </div>
          <div class="col-sm-1">
            <div class="btn btn-secondary" @click="addHtml">
              增加
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="form-group" style="text-align:center;">
        <div class="btn btn-light" @click="submit(2)">
          存草稿
        </div>
        <div class="btn btn-primary" @click="submit(1)">
          提交审核
        </div>
      </div>
    </div>
    <alert-model v-bind:func="alertFunc" v-bind:show="alertShow" v-on:close="catchClose" v-bind:msg="tips"></alert-model>
  </div>
</template>

<script>
import Vue from 'vue'
import commonHeader from './header.vue'
import stepThird from './step3.vue'
import alertModel from './alert.vue'
export default {
  data() {
    return {
      inputGroup: [1],
      count: 1,
      formData: [],
      alertShow: false,
      tips: '',
      alertFunc: ''
    }
  },
  components: {
    commonHeader,
    stepThird,
    alertModel
  },
  methods: {
    catchRemoveIndex(index) {
      this.inputGroup.splice(index, 1);
    },
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      console.log(msg, func)
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    addHtml() {
      this.count++
      this.inputGroup.push(this.count)
    },
    catchFormData(data) {
      this.formData[data.index] = (data.formData[data.index])
    },
    submit(op) {
      let id = this.$route.query.id
      let formData = []
      for (let i = 0; i < this.formData.length; i++) {
        formData.push(this.formData[i])
      }
      let config = {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
      this.$axios.post("/api/wenlian/step3",
        {
          data: formData,
          request_id: id,
          op: op
        }, config).then(res => {
          if (res.data.result == 1) {
            if (op == 2) {
              this.alert('保存成功', () => {
                this.$router.push('/')
              })
            } else {
              this.$router.push('/submit')
            }
          } else {
            this.alert(res.data.msg)
          }

        })
    }
  },
  mounted() {
  }
}
</script>

<style lang="css" scoped>
.step3 .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.step3 .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}
.step3 .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}
.step3 .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.step3 .btn-light {
  width: 200px;
  margin-right: 15px;
}
.step3 .btn-secondary {
  margin-top: 10px;
}
.step3 .part {
  padding: 20px 0;
}
.step3 .border {
  width: 100%;
}
.step3 .fullScreen {
  height: 100%;
}
.step3 .page-link {
  color: #33434b;
}
.step3 .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}
.step3 .page-link.active {
  background: #f4f4f4;
}
.step3 .custom-file-label::after {
  content: "证明材料上传";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}
.step3 .custom-file-label {
  border: none;
}
.step3 .red {
  color: red;
  margin: 0 5px;
}
.step3 .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
}
.step3 table td,
table th {
  color: #333;
}
.step3 .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}
.step3 .form-group {
  margin-bottom: 0;
}
.step3 .upload-image {
  margin-top: 20px;
}
.step3 .upload-image img {
  height: 150px;
  width: auto;
}
.step3 .custom-file {
  margin-top: 0%;
}
.step3 .example-img {
  height: 150px;
  width: 200px;
  border: 1px solid #33434b;
  border-radius: 5px;
  position: relative;
}
.step3 .example-img:after {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #33434b;
  font-size: 50px;
}
.step3 table thead tr th:nth-child(3) {
  width: 60%;
}
.step3 .row {
  margin: 0;
}

@media screen and (max-width: 750px) {
  .table {
    width: 1000px !important;
  }
  .table thead tr th:first-child,
  .table thead tr th:nth-child(2) {
    width: 280px !important;
  }
  .table thead tr th:nth-child(3) {
    width: 300px !important;
  }
  .step3 .btn-light {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applyStep3.vue